<template>
  <div>
    <span class="label-text">
      <template v-if="!shipAvailable">
        Not available for shipping <span v-if="zipCode">to</span>
      </template>
      <template v-else-if="isEGiftCard">
        Email
      </template>
      <template v-else-if="isFurnitureShipping && furnitureShippingMessage">
        Furniture Shipping <span class="label-to">- {{ furnitureShippingMessage }}</span>
      </template>
      <template v-else-if="isParcelShipping">
        Parcel Shipping <span class="label-to">to </span>
      </template>
      <template v-else-if="freeShippingEligible && zipCode">
        Free shipping <span class="label-to">to </span>
      </template>
      <template v-else-if="shipTo && !freeShippingEligible">
        Ship <span class="label-to">to </span>
      </template>
      <template v-else>
        Ship
      </template>
    </span>
  </div>
</template>

<script>
export default {
  name: 'ShipItRadioLabelText',
  props: {
    shipTo: {
      type: String,
      default: '',
    },
    isEGiftCard: {
      type: Boolean,
      default: false,
    },
    isParcelShipping: {
      type: Boolean,
      default: false,
    },
    isFurnitureShipping: {
      type: Boolean,
      default: false,
    },
    furnitureShippingMessage: {
      type: String,
      default: '',
    },
    shipAvailable: {
      type: Boolean,
      default: false,
    },
    zipCode: {
      type: String,
      default: '',
    },
    freeShippingEligible: {
      type: Boolean,
      default: false,
    },
    isInternationalShip: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.label-text {
  font-weight: 500;
}
.label-to {
  font-weight: 400;
}
</style>
